import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getCookieConsent,
  setCookieConsent,
} from "../../utils/cookie";
import "./CookieConsent.css";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
  const consent = getCookieConsent();
  console.log("Consent:", consent);
  if (!consent) setShow(true);
}, []);


  const handleAccept = () => {
    setCookieConsent("accepted");
    setShow(false);
  };

  const handleDecline = () => {
    setCookieConsent("declined");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookiebox">
      <div className="textbox">
        <span>
          By using our site, you acknowledge that you read and understand our{" "}
          <Link to="/privacy-policy" target="_blank">
            Privacy Policy
          </Link>
          .
        </span>
      </div>

      <div className="btnbox">
        <button className="btn1" onClick={handleDecline}>
          Decline
        </button>
        <button className="btn2" onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
